import { IDatasource } from "@cak-legacy/generation-core";
import { UseFormProps } from "react-hook-form";
import { renderAddedSchemaFields } from "./renderAddedSchemaFields";

export interface IFormButton {
  label: string;
  id: string;
  layout: "primary" | "secondary" | "transparent";
  disabled?: boolean;
  isLoading?: boolean;
}

export interface SubmitButton extends IFormButton {
  type: "submit";
  handle: (values: any, event: React.FormEvent, context: FormSubmitContext) => void;
}

export interface FormSubmitContext {
  setError: (property: string, message: string, type?: string) => void;
  setValues: (
    items: { key: string; value: string | undefined | { [key: string]: string | undefined } }[],
    shouldValidate?: boolean
  ) => void;
  reset: () => void;
}

export interface FormButtonContext {
  handleSubmit: (
    onValid: (data: any, event: React.FormEvent) => void,
    onInvalid?: (errors: any, event: React.FormEvent) => void
  ) => Promise<void>;
}

export interface FormButton extends IFormButton {
  type: "button";
  handle: (formButtonContext?: FormButtonContext) => void;
}

export interface ResetButton extends IFormButton {
  type: "reset";
  handle?: (event?: React.FormEvent) => void;
}

export type FormButtons = SubmitButton | ResetButton | FormButton;

export const enum SelectLibrary {
  "ReactSelect",
  "DownShift"
}

export interface IFormSettingProps {
  uiDefaults?: {
    flexDirectionFormGroupControl?: "row" | "row-reverse" | "column" | "column-reverse";
  };
  fieldDefaults?: {
    text?: {
      maxLengthMessage?: boolean;
    };
    textArea?: {
      counterAndMaxLengthMessage?: boolean;
      counterUnit?: string;
    };
    select?: {
      library?: SelectLibrary;
    };
  };
  dependsOn?: {
    keepDefaultValues?: boolean;
    keepValues?: boolean;
  };
}

export interface IFormProps<TSchema> extends IFormSettingProps {
  hide?: boolean;
  schema: TSchema;
  datasources?: IDatasource[];
  formOptions?: UseFormProps;
  afterFormFieldsContent?: React.ReactNode;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  /**
   * @deprecated use buttonsList
   */
  handleSubmit?: (values: any, event: React.FormEvent) => void;
  /**
   * @deprecated use buttonsList instead of buttons
   */
  buttons?: {
    submit?: { id?: string; label: string };
    reset?: { id?: string; label: string };
  };
  buttonList?: FormButtons[];
  /**
   * @deprecated use buttonsList
   */
  handleReset?: (event?: React.FormEvent) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onShowButtons?: (values: any) => boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (values: any) => void;
  renderAddedSchemaFields?: renderAddedSchemaFields;
}
